import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { Paths } from '@constants/paths';

export const QuestionnairePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate(Paths.NOT_FOUND);
    }
  }, [id]);
  return (
    <Container>
      <Outlet />
    </Container>
  );
};
